module.exports = __webpack_public_path__ + "media/src/images/icon/sns/ig-610b59a8a1ec089d4402f9753985c0cd.png";